import { isNil } from 'ramda';

const MAX_LENGTH_BREAKPOINT = 50;

export const isValueTooLong = value => {
  if (isNil(value)) return false;
  return value.length > MAX_LENGTH_BREAKPOINT;
};
